import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { usePurchaseEnquiryModel } from "../purchaseEnquiryModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchaseEnquiryDetailsModel } from "./details/purchaseEnquiryDetailsModel"
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { PurchaseTable } from "./PrintPurchaseTable";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";

export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, descRows, exportPurchaseEnquiry } = usePurchaseEnquiryModel();
    const { setDetailEditForm, setDetailDataSource } = usePurchaseEnquiryDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const [printVisible, setPrintVisible] = useState<boolean>(false);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-6-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRow.id as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "采购订单跳转详情",
                type: "warning",
                text: "您还有采购订单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRow.id as string, mode: "edit" });
                    // updateEditFormVal(null);
                    setDetailEditForm({})
                    setDetailDataSource([])
                }
            })
        }
    }
    const desc: IDescription[] = [
        {
            label: "计划总量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "计划总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        }
    ]
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-6-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.id as string, mode: "look", },
            true
        );

    }
    const onPrint = () => {
        if (selectedRowKeys.length === 0) {
            globalPrompt("message", { text: "请选择数据进行打印！", type: "warning" });
            return;
        }
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行打印！", type: "warning" });
            return;
        }
        setPrintVisible(true);
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_ADD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("11-6-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_EDIT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_LOOK}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_EXPORTPURCHASE}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { exportPurchaseEnquiry().then() }}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_ONPRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint()}
            >打印</Button>
        </YhAuth>
    </>;

    return (
        <>
            {/* <YhBox title={"采购订单列表"} descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}> */}
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            <PurchaseTable printVisible={printVisible} setPrintVisible={setPrintVisible} />
        </>
    )
}